import { CenteredLazyLoading } from "@/controls/CenteredLazyLoading";
import { ErrorModal } from "@dexteel/mesf-core";
import { Paper, Typography } from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { getCatalogGrades } from "../../repositories/CatalogGradeRepository";
import { useCatalogGradeContext } from "./CatalogGradeContext";
import { TableGrade } from "./components/TableGrade";

type Props = {};
export const CatalogGradePage = (props: Props) => {
	const { state, actions } = useCatalogGradeContext();
	const { gradeId } = useParams();

	const [isLoading, setIsLoading] = useState(true);
	const [error, setError] = useState("");

	const getCatalogGradesFromAPI = async () => {
		setIsLoading(true);
		const resp = await getCatalogGrades();
		if (resp.ok) {
			actions.setGrades(resp.data.tables[0].rows);
			setIsLoading(false);
		} else {
			setError(resp.message);
		}
	};

	useEffect(() => {
		getCatalogGradesFromAPI();
	}, []);

	if (state.grades) {
		return (
			<>
				<Grid container justifyContent="center" alignItems="center">
					<Grid item md={12} xs={12} style={{ padding: "0 15px" }}>
						<Typography variant="h5" style={{ fontWeight: 600 }}>
							Grades
						</Typography>
					</Grid>

					<Grid item container md={12} xs={12} style={{ margin: 0 }}>
						<Paper
							elevation={0}
							style={{
								width: "100%",
								padding: "15px 20px 10px",
								borderRadius: "0.75rem",
							}}
						>
							<TableGrade
								gradeId={gradeId}
								isLoading={isLoading}
								getCatalogGradesFromAPI={getCatalogGradesFromAPI}
							/>
						</Paper>
					</Grid>
				</Grid>
				<ErrorModal error={error} onHide={() => setError("")} />
			</>
		);
	}
	return <CenteredLazyLoading />;
};
